import i18n from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { LanguageCodes } from './constants';

/** Languages supported by the application. Must have complete translation files. */
const supportedLngs = Object.values(LanguageCodes);

/**
 * Initialize the i18n instance using the given configuration.
 * @param {object} resources Translation files, provided using valid i18n resources structure.
 * @param {boolean} debug Indicates if i18n `debug` mode should be used.
 * @returns {Promise} Should wait for callback or promise resolution before using the translation function.
 */
const configureI18n = (resources, debug) => {
  if (!i18n.isInitialized) {
    i18n
      .use(I18nextBrowserLanguageDetector)
      .use(initReactI18next)
      .init({
        resources,
        debug,
        defaultLanguage: LanguageCodes.EN,
        fallbackLng: LanguageCodes.EN,
        supportedLngs,
        react: {
          useSuspense: false,
        },
        detection: {
          order: ['path', 'navigator'],
          lookupFromPathIndex: 0,
          caches: [],
        },
      });
  }
  return i18n;
};

export default configureI18n;
